import { useEffect } from 'react';

export const usePostMessageListener = (messageHandler: (eventProps: any) => void) => {
  useEffect(() => {
    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [messageHandler]);
};
